import { InputType } from './../EditComponent';
import { CustomDatePicker } from './../CustomDatePicker';
import { getUTCDate, getUTCRunDate, isMonthYearLabel } from '../../../../utils/helpers';

interface DateEditComponentProps {
  label?: string;
  val: string | number | null | boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handler: (v: string | number | null | any, d?: string) => void;
  handleClose: () => void;
  setLocalVal: (v: InputType) => void;
}

export const DateEditComponent = ({ label, val, handler, handleClose, setLocalVal }: DateEditComponentProps) => {
  const isMonthYear = isMonthYearLabel(label || '');

  const handleDateChange = (date: Date | null) => {
    let dateValue = date;
    if (dateValue && dateValue.toString() != 'Invalid Date') {
      if (isMonthYear) dateValue = getUTCRunDate(dateValue);
      else dateValue = getUTCDate(dateValue);
    } else {
      dateValue = null;
    }
    setLocalVal(dateValue);

    if (dateValue) {
      handler(dateValue.toISOString());
    } else {
      handler(null);
    }
  };

  return (
    <CustomDatePicker
      value={val}
      onChange={handleDateChange}
      onClose={handleClose}
      isMonthYear={isMonthYear}
    />
  );
};
